module.exports = __webpack_public_path__ + "static/media/mapTaxiLess.17bb4686.png";